import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { required } from '../../util/validators';
import {
    FieldRadioButton,
    SecondaryButton,
    Form,
    FieldCheckbox,
    FieldTextInput,
} from '../../components';
import css from './AdminPageFlipAndWin.css';

export default ({ onSubmit, initialValues = {}, action }) => (
    <FinalForm
        keepDirtyOnReinitialize
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={fieldRenderProps => {
            const { handleSubmit, values, form } = fieldRenderProps;
            const { type, countries, logo, probability, title, voucherCode, voucherLink, amount } =
                values || {};

            const isCredits = type === 'credits';
            const isCoupon = type === 'coupon';
            const isProduct = type === 'product';

            const disabled =
                !type ||
                !logo ||
                !countries ||
                countries.length === 0 ||
                !title ||
                !probability ||
                (isCredits ? !amount : false) ||
                (isCoupon ? !voucherCode : false) ||
                (isProduct ? !voucherLink : false);

            return (
                <Form onSubmit={handleSubmit} className={css.form}>
                    <div>
                        <p>Type *</p>
                        <FieldRadioButton
                            form={form}
                            id="credits"
                            name="type"
                            label="Credits"
                            value="credits"
                        />
                        <FieldRadioButton
                            form={form}
                            id="coupon"
                            name="type"
                            label="Coupon"
                            value="coupon"
                        />
                        <FieldRadioButton
                            form={form}
                            id="product"
                            name="type"
                            label="Product"
                            value="product"
                        />
                    </div>
                    <div>
                        <p>Countries *</p>
                        <FieldCheckbox
                            type="checkbox"
                            id="CH"
                            name="countries"
                            label="Schweiz"
                            value="CH"
                            form={form}
                        />
                        <FieldCheckbox
                            type="checkbox"
                            id="DE"
                            name="countries"
                            label="Deutschland"
                            value="DE"
                            form={form}
                        />
                    </div>
                    <div>
                        <p>Add query params</p>
                        <FieldCheckbox
                            type="checkbox"
                            id="withParams"
                            name="withParams"
                            label="uuid, city, postal code, etc"
                            form={form}
                        />
                    </div>
                    <div>
                        <p>Logo *</p>
                        <FieldTextInput
                            type="text"
                            id="logo"
                            name="logo"
                            placeholder="https://"
                            validate={required('This field is required')}
                        />
                    </div>
                    <div>
                        <p>Winning Chance *</p>
                        <FieldTextInput
                            type="number"
                            id="probability"
                            name="probability"
                            placeholder="10,20,30"
                            validate={required('This field is required')}
                        />
                    </div>
                    <div>
                        <p>Title *</p>
                        <FieldTextInput
                            type="text"
                            id="title"
                            name="title"
                            placeholder="Title"
                            validate={required('This field is required')}
                        />
                    </div>
                    <div>
                        <p>Teaser Text</p>
                        <FieldTextInput
                            type="textarea"
                            id="teaserText"
                            name="teaserText"
                            placeholder="Teaser Text"
                        />
                    </div>
                    {isCredits && (
                        <div>
                            <p>Credits Amount *</p>
                            <FieldTextInput
                                type="text"
                                id="amount"
                                name="amount"
                                placeholder="10,20,30"
                                validate={required('This field is required')}
                            />
                        </div>
                    )}
                    {isCoupon && (
                        <div>
                            <p>Code *</p>
                            <FieldTextInput
                                type="text"
                                id="voucherCode"
                                name="voucherCode"
                                placeholder="E.i. HORSEDEAL10"
                                validate={required('This field is required')}
                            />
                        </div>
                    )}
                    {isProduct && (
                        <div>
                            <p>Link *</p>
                            <FieldTextInput
                                type="text"
                                id="voucherLink"
                                name="voucherLink"
                                placeholder="E.i. https://www.horsedeal.com"
                                validate={required('This field is required')}
                            />
                        </div>
                    )}
                    <div>
                        <p>Dialog Acc. 1</p>
                        <FieldTextInput
                            type="text"
                            id="dialogAcc1"
                            name="dialogAcc1"
                            placeholder="Dialog Acc. 1"
                        />
                    </div>
                    <div>
                        <p>Dialog Text 1</p>
                        <FieldTextInput
                            type="textarea"
                            id="dialogText1"
                            name="dialogText1"
                            placeholder="Dialog Text 1"
                        />
                    </div>
                    <div>
                        <p>Dialog Acc. 2</p>
                        <FieldTextInput
                            type="text"
                            id="dialogAcc2"
                            name="dialogAcc2"
                            placeholder="Dialog Acc. 2"
                        />
                    </div>
                    <div>
                        <p>Dialog Text 2</p>
                        <FieldTextInput
                            type="textarea"
                            id="dialogText2"
                            name="dialogText2"
                            placeholder="Dialog Text 2"
                        />
                    </div>
                    <div>
                        <p>Dialog Acc. 3 (Website)</p>
                        <FieldTextInput
                            type="text"
                            id="dialogAcc3"
                            name="dialogAcc3"
                            placeholder="Dialog Acc. 3"
                        />
                    </div>
                    <div>
                        <p>Dialog Text 3 (Website)</p>
                        <FieldTextInput
                            type="textarea"
                            id="dialogText3"
                            name="dialogText3"
                            placeholder="Dialog Text 3"
                        />
                    </div>
                    <footer>
                        <SecondaryButton disabled={disabled} type="submit">
                            admin::{action}
                        </SecondaryButton>
                    </footer>
                </Form>
            );
        }}
    />
);
